
import { defineComponent } from "vue";

export default defineComponent({
  name: "BModal",
  props: {
    fullscreen: {
      type: Boolean,
      required: false,
			default: false,
    },
		toggle: {
      type: Boolean,
      required: true,
    },
  },
	setup(_, ctx) {
		function onCloseClick() {
			ctx.emit('on-close-click')
		}
		return { onCloseClick }
	}
  // type inference enabled
});
